const cleanTikTokUsername = (value) => String(value || '').trim().replace(/^@+/, '');

const getOrderTimestamp = (order) => {
  const value = order.updatedAt || order.createdAt || order.deliveryDate || '';
  const timestamp = Date.parse(value);
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const getDeliveryYearAndMonth = (value) => {
  const dateOnlyMatch = String(value || '').match(/^(\d{4})-(\d{2})/);
  if (dateOnlyMatch) {
    return { year: Number(dateOnlyMatch[1]), month: Number(dateOnlyMatch[2]) - 1 };
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return { year: date.getFullYear(), month: date.getMonth() };
};

export const getMonthlyOrderVolume = (completedOrders = [], year = new Date().getFullYear()) => {
  const counts = Array(12).fill(0);

  completedOrders.forEach(order => {
    if (!order.deliveryDate || order.deliveryDate === 'TBD') return;
    const delivery = getDeliveryYearAndMonth(order.deliveryDate);
    if (delivery?.year === year && delivery.month >= 0 && delivery.month < 12) {
      counts[delivery.month] += 1;
    }
  });

  return MONTH_LABELS.map((label, month) => ({ label, count: counts[month], month, year }));
};

export const getTopReturningCustomers = (completedOrders = [], limit = 5) => {
  const customers = new Map();

  completedOrders.forEach(order => {
    const displayName = String(order.customer || 'Unknown').trim() || 'Unknown';
    const key = displayName.toLowerCase();
    const current = customers.get(key) || {
      name: displayName,
      count: 0,
      revenue: 0,
      tiktokUsername: '',
      tiktokUsernameUpdatedAt: -1
    };

    current.count += 1;
    current.revenue += parseFloat(order.total) || 0;

    const tiktokUsername = order.platform?.toLowerCase() === 'tiktok'
      ? cleanTikTokUsername(order.username)
      : '';
    const timestamp = getOrderTimestamp(order);
    if (tiktokUsername && timestamp >= current.tiktokUsernameUpdatedAt) {
      current.tiktokUsername = tiktokUsername;
      current.tiktokUsernameUpdatedAt = timestamp;
    }

    customers.set(key, current);
  });

  return [...customers.values()]
    .map(({ tiktokUsernameUpdatedAt, ...customer }) => customer)
    .sort((a, b) => b.count - a.count || b.revenue - a.revenue)
    .slice(0, limit);
};
